<template>
  <div class="inspection-center">
    <div class="metrics-grid">
      <div class="metric-card" v-for="(item, index) in basicMetrics" :key="index">
        <div class="metric-icon">
          <img :src="getIconUrl(index)" alt="" />
        </div>
        <div class="metric-content">
          <div class="metric-label">{{ item.title }}</div>
          <div class="metric-value">{{ formatNumber(item.num) }}</div>
        </div>
      </div>
    </div>
    
    <div class="yearly-stats">
      <div class="stat-item" v-for="(item, index) in dailyMetrics" :key="index">
        <div class="stat-title">{{ item.title }}</div>
        <div class="stat-value">{{ formatNumber(item.num) }}</div>
        <div class="stat-trend" :class="getTrendClass(item.hb)">
          <i :class="getTrendIcon(item.hb)"></i>
          {{ formatTrend(item.hb) }}
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import { postAction } from '@/api/manage'
export default {
  name: 'InspectionCenter',
  data() {
    return {
      title: this.$t('本月任务'),
      basicMetrics: [
        { title: this.$t('计划巡检'), num: 0 },
        { title: this.$t('实际巡检'), num: 0 },
        { title: this.$t('计划保养'), num: 0 },
        { title: this.$t('实际保养'), num: 0 }
      ],
      dailyMetrics: [
        { title: this.$t('当日巡检任务数'), num: 0, hb: 0 },
        { title: this.$t('当日未巡检任务数'), num: 0, hb: 0 },
        { title: this.$t('当日即将过期任务数'), num: 0, hb: 0 }
      ],
      url: {
        indexTodayToDoTaskByUser: "/jeecg-engineering/inspection/inspectionTask/LargeScreenTodayDTicketsNum",
        indexTodayDoneTaskByUser: "/jeecg-engineering/inspection/inspectionTask/LargeScreenTodayUnToDo",
        indexWillEndTaskByUser: "/jeecg-engineering/inspection/inspectionTask/LargeScreenTodayWillEndTickets",
        LargeScreenSumMonth: "/jeecg-engineering/inspection/inspectionTask/LargeScreenSumMonth"
      }
    }
  },
  mounted() {
    this.init()
  },
  methods: {
    init() {
      this.getTodayToDoTaskByUser();
      this.getTodayDoneTaskByUser();
      this.getWillEndTaskByUser();
      this.getData();
    },
    // 当日巡检任务数
    getTodayToDoTaskByUser() {
      postAction(this.url.indexTodayToDoTaskByUser, {}).then(res => {
        if (res.success) {
          const data = res.result;
          this.dailyMetrics[0].num = data.toDo;
          this.dailyMetrics[0].hb = data.compareToDoRate;
        }
      })
    },
    // 未巡检任务数
    getTodayDoneTaskByUser() {
      postAction(this.url.indexTodayDoneTaskByUser, {}).then(res => {
        if (res.success) {
          const data = res.result;
          this.dailyMetrics[1].num = data.done;
          this.dailyMetrics[1].hb = data.compareDoneRate;
        }
      })
    },
    // 即将过期任务数
    getWillEndTaskByUser() {
      postAction(this.url.indexWillEndTaskByUser, {}).then(res => {
        if (res.success) {
          const data = res.result;
          this.dailyMetrics[2].num = data.willEnd;
          this.dailyMetrics[2].hb = data.compareWillEndRate;
        }
      })
    },
    getData() {
      postAction(this.url.LargeScreenSumMonth, { queryType: 2 }).then(res => {
        if (res.success) {
          const data = res.result;
          this.basicMetrics[0].num = data.inspectionPlanNum;
          this.basicMetrics[1].num = data.inspectionFinishNum;
          this.basicMetrics[2].num = data.maintenancePlanNum;
          this.basicMetrics[3].num = data.maintenanceFinishNum;
        }
      })
    },
    getIconUrl(index) {
      const icons = [
        require('@/assets/images/menu-yw.png'),
        require('@/assets/images/menu-yw.png'),
        require('@/assets/images/menu-yw.png'),
        require('@/assets/images/menu-yw.png')
      ]
      return icons[index]
    },
    formatNumber(num) {
      return num.toLocaleString()
    },
    getTrendClass(hb) {
      return hb >= 0 ? 'trend-up' : 'trend-down'
    },
    getTrendIcon(hb) {
      return hb >= 0 ? 'el-icon-caret-top' : 'el-icon-caret-bottom'
    },
    formatTrend(hb) {
      const value = Math.abs(hb * 100).toFixed(1)
      return hb >= 0 ? `+${value}%` : `-${value}%`
    }
  }
}
</script>

<style lang="less" scoped>
.inspection-center {
  height: 100%;
  padding: 10px;
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.metrics-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 20px;
}

.metric-card {
  background: linear-gradient(135deg, rgba(1, 32, 67, 0.8) 0%, rgba(0, 48, 111, 0.6) 100%);
  border: 1px solid rgba(0, 170, 255, 0.3);
  border-radius: 8px;
  padding: 24px;
  display: flex;
  align-items: center;
  gap: 15px;
  transition: all 0.3s ease;
  
  &:hover {
    transform: translateY(-2px);
    border-color: rgba(0, 170, 255, 0.6);
    box-shadow: 0 4px 12px rgba(0, 170, 255, 0.2);
  }
}

.metric-icon {
  width: 50px;
  height: 50px;
  
  img {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
}

.metric-content {
  flex: 1;
}

.metric-label {
  color: #b6deff;
  font-size: 14px;
  margin-bottom: 5px;
}

.metric-value {
  color: #fff;
  font-size: 28px;
  font-weight: bold;
  font-family: 'ds-digital-bold';
}

.yearly-stats {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 15px;
}

.stat-item {
  background: rgba(0, 48, 111, 0.4);
  border: 1px solid rgba(0, 170, 255, 0.2);
  border-radius: 6px;
  padding: 24px;
  text-align: center;
  transition: all 0.3s ease;
  
  &:hover {
    background: rgba(0, 48, 111, 0.6);
    border-color: rgba(0, 170, 255, 0.4);
  }
}

.stat-title {
  color: #a8c6f3;
  font-size: 12px;
  margin-bottom: 8px;
}

.stat-value {
  color: #fff;
  font-size: 24px;
  font-weight: bold;
  font-family: 'ds-digital-bold';
  margin-bottom: 5px;
}

.stat-trend {
  font-size: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 3px;
  
  &.trend-up {
    color: #52c41a;
  }
  
  &.trend-down {
    color: #ff4d4f;
  }
}

@media (max-width: 1600px) {
  .metrics-grid {
    grid-template-columns: 1fr;
    gap: 15px;
  }
  
  .yearly-stats {
    grid-template-columns: repeat(2, 1fr);
    gap: 10px;
  }
}

@media (max-width: 1200px) {
  .yearly-stats {
    grid-template-columns: 1fr;
  }
  
  .metric-card {
    padding: 12px;
  }
  
  .stat-item {
    padding: 12px;
  }
}
</style>